import * as signalR from '@aspnet/signalr';
import store from '../store';

let chatConnection: signalR.HubConnection;
let reconnectTimeoutId: ReturnType<typeof setTimeout> | null = null;
let reconnectAttempts = 0;
const MAX_RECONNECT_DELAY_MS = 60000;
const BASE_RECONNECT_DELAY_MS = 5000;

async function connect(conn: signalR.HubConnection) {
  if (reconnectTimeoutId !== null) {
    clearTimeout(reconnectTimeoutId);
    reconnectTimeoutId = null;
  }

  conn
    .start()
    .then(() => {
      reconnectAttempts = 0;
    })
    .catch((e: any) => {
      console.error('[GroupChatHub] connection failed:', e);
      const delay = Math.min(
        BASE_RECONNECT_DELAY_MS * Math.pow(2, reconnectAttempts),
        MAX_RECONNECT_DELAY_MS
      );
      reconnectAttempts++;
      reconnectTimeoutId = setTimeout(() => {
        reconnectTimeoutId = null;
        connect(conn);
      }, delay);
    });
}

let initialized = false;

export default {
  init() {
    if (initialized && chatConnection) {
      return;
    }

    const token: string = store.getters.token;
    chatConnection = new signalR.HubConnectionBuilder()
      .withUrl(process.env.VUE_APP_HUB_ROOT + '/chathub', {
        accessTokenFactory: () => token,
      })
      .build();

    chatConnection.onclose(() => {
      connect(chatConnection);
    });

    initialized = true;
    connect(chatConnection);
  },

  getConnection() {
    return chatConnection;
  },

  sendTyping() {
    if (chatConnection) {
      chatConnection.invoke('UserTyping').catch((err: any) => {
        console.error('[GroupChatHub] typing signal failed:', err);
      });
    }
  },
};
